import React, { Component } from 'react';
import moment from 'moment';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { DATE_FORMAT } from '../constants';
import Pikaday from './Pikaday';

class DateInput extends Component {

	state = {
		focus: false,
	};

	today = moment();
	tomorrow = moment().add(1, 'day');

	pikadayInitialOptions = {
		format: DATE_FORMAT,
		disableDayFn: (date) => {
			if (this.props.minDate && moment(date).isBefore(this.props.minDate, 'day')) {
				return true;
			} else if (this.props.maxDate && moment(date).isAfter(this.props.maxDate, 'day')) {
				return true;
			}

			if (this.props.input.name === 'arrival') {
				return moment(date).isBefore(this.today, 'day');
			} else if (this.props.input.name === 'departure') {
				return moment(date).isBefore(this.tomorrow, 'day');
			}

			return false;
		},
		onSelect: (date) => {
			this.setValue(date);
		},
	};

	focus = (e) => {
		e.target.setAttribute('data-date', e.target.value);
		this.setState({ focus: true });
	};

	blur = (e) => {
		let date = moment(e.target.value, DATE_FORMAT);
		if (!date.isValid()) {
			e.target.value = e.target.getAttribute('data-date');
		}
		this.setState({ focus: false });
	};

	setPickerInstance = (picker) => {
		this.picker = picker;
	};

	setValue(date) {
		this.props.input.onChange(moment(date).format(DATE_FORMAT));
	}

	getValue() {
		return moment(this.props.input.value, DATE_FORMAT);
	}

	render() {
		const { fontAwesomeIconBig, lang, disabled } = this.props;

		const value = this.getValue();
		const hasValue = value.isValid();

		const initialOptions = {
			...this.pikadayInitialOptions,
			i18n: this.props.i18n,
			...(this.props.yearRange ? { yearRange: this.props.yearRange } : {}),
			...(this.props.defaultAnchorDate ? {
				defaultDate: this.props.defaultAnchorDate.toDate(), // určuje, na jaký měsíc/rok se kalendář otevře poprvé
				setDefaultDate: false,
			} : {}),
		};

		return (

			<div className={`large-input ${fontAwesomeIconBig ? 'large-input--with-big-icon' : ''} ${this.state.focus ? 'large-input--focus' : ''} ${hasValue ? 'large-input--filled' : ''} ${disabled ? 'large-input--disabled' : ''} ${this.props.className || ''}`}>

				{!!fontAwesomeIconBig &&
				<FontAwesomeIcon
					icon={fontAwesomeIconBig}
					className="large-input__big-icon"
				/>
				}

				<Pikaday
					key={lang} // překreslit pokud se změní locale
					className="input input--date"
					// Tohle děláme kvůli problémům s časovýma zónama. Pokud pole nemá vyplněnou hodnotu (např.
					// nepovinné datum narození), pošleme null, aby zůstalo prázdné.
					value={hasValue ? new Date(value.format('YYYY'), parseInt(value.format('M'), 10) - 1, value.format('D')) : null}
					initialOptions={initialOptions}
					onFocus={this.focus}
					onBlur={this.blur}
					setPickerInstance={this.setPickerInstance}
					readOnly
					disabled={disabled}
				/>
				<label htmlFor={this.props.id}>{this.props.label}</label>
			</div>

		);
	}
}

const i18n = createSelector(
	[state => state.app.lang],
	(lang) => {
		// načíst jazyková data z moment.js
		const localeData = moment.localeData(lang || 'en');
		return {
			months: localeData.months(),
			weekdays: localeData.weekdays(),
			weekdaysShort: localeData.weekdaysShort(),
		};
	}
);


export default compose(
	connect(state => ({
		i18n: i18n(state),
		lang: state.app.lang,
	}))
)(DateInput);


// WEBPACK FOOTER //
// ./src/components/DateInput.jsx